(function(window, $) {
    if ($('table').length) {
        var prevScrollTop = 0;
        var theadOffset = $('table').offset().top;

        $.fn.stickyTable = function() {
            var $table = $(this),
                $thead = $(this)
                    .find('thead')
                    .clone();

            // Create wrapper
            var $stickyWrap = $('<div />', {
                class: 'sticky-table'
            });

            $table.wrap($stickyWrap);

            // Create new sticky table head
            var tableClasses = $table.attr('class');
            var $stickyHead = $('<table />', {
                class: tableClasses + ' sticky-table__head',
                css: {
                    width: $table.width()
                }
            });

            $table.after($stickyHead);

            // Sticky header gets all content from <thead>
            $stickyHead.append($thead);

            var $stickyCols = $stickyHead.find('th');

            function setColumnWidths() {
                if ($stickyHead) {
                    $stickyHead.css('width', $table.width());
                }

                $table.find('th').each(function(i, el) {
                    var w = $(el).width();
                    $stickyCols.eq(i).css({
                        width: w
                    });
                });
            }

            function scroll() {
                var scrollTop = $(window).scrollTop() - theadOffset;

                // Duration based on scroll direction
                var duration = scrollTop > prevScrollTop ? '150ms' : '0ms';
                if ($stickyHead) {
                    $stickyHead.css({
                        transitionDuration: duration,
                        transform: 'matrix(1, 0, 0, 1, 0, ' + Math.max(scrollTop, 0) + ')'
                    });
                }

                prevScrollTop = scrollTop;
            }

            $(document).ready(function() {
                setColumnWidths();
                scroll();

                $("[data-toggle='column']").on('change', function() {
                    var id = $(this).data('target');
                    var $th = $(".table th[data-column='" + id + "']");
                    var $cells = $('#results td:nth-child(' + ($th.index() + 1) + ')');
                    if (this.checked) {
                        $th.show();
                        $cells.show();
                    } else {
                        $th.hide();
                        $cells.hide();
                    }
                    setColumnWidths();
                });
            });

            $(window).on('scroll', function() {
                scroll();
            });

            $(window).on('resize', function() {
                setColumnWidths();
                scroll();
            });

            window.addEventListener('orientationchange', function() {
                setTimeout(function() {
                    setColumnWidths();
                    scroll();
                }, 300);
            });
        };
    }
})(window, jQuery);
